import React from 'react';

interface LeadCaptureSectionProps {
  email: string;
  isSubmitting: boolean;
  error: string;
  onEmailChange: (value: string) => void;
  onSubmit: (event: React.FormEvent) => void;
}

const LeadCaptureSection: React.FC<LeadCaptureSectionProps> = ({
  email,
  isSubmitting,
  error,
  onEmailChange,
  onSubmit
}) => {
  return (
    <section className=" mx-auto px-6 pt-6 pb-8 text-center bg-[#edf1f9]">
      <span className="text-[25px] md:text-[30px] text-[#1A2A44] font-[500] mr-2 text-center">
          Mining Super-Cycle: 
        </span>
        <span className="text-[25px] md:text-[30px] text-[#1A2A44] font-[700]">
          2025 Recap & 2026 Strategic Outlook
        </span>
      <form onSubmit={onSubmit} className="mt-5">
        <input
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          type="email"
          placeholder="yourbest@email.com"
          className="w-full max-w-[460px] h-[52px] px-5 rounded-full text-center text-[18px] focus:outline-none focus:ring-2 focus:ring-[#D3A12A]"
          required
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="block mt-4 w-full max-w-[560px] mx-auto h-[48px] md:h-[52px] rounded-[8px] bg-[#D3A12A] text-white font-[700] text-[16px] sm:text-[18px] md:text-[22px] leading-none px-4 hover:bg-[#ae8a2a] disabled:bg-gray-400"
        >
          {isSubmitting ? 'Submitting...' : 'Grab The Full Report Now'}
        </button>
      </form>

      {error && <p className="mt-3 text-[14px] text-red-700">{error}</p>}
    </section>
  );
};

export default LeadCaptureSection;
